<template>
  <div class="vg-content" >
    <div class="logo" style="margin-left: 1px;">
      <van-image width="65" height="32.5" :src="srcLogo"/>
    </div>
    <div style="text-align: center; margin-top: -35px; margin-bottom: 225px;" @click="onChangeProject">
      <span>{{ project.projectName }}</span>
      <van-icon v-if="!project.onlyOne" name="arrow-down" size="20px" style="margin-left: 10px;"/>
    </div>

    <van-button v-if="get73Resource" class="button" :icon="srcScan" @click="scanVerify">扫码验真</van-button>
    <van-button v-if="get74Resource" class="button" :icon="srcCharge" style="margin-top: 30px;" @click="sporadicCharges">零星收费</van-button>
    <div class="footer" v-if="get86Resource">
      <van-image width="16" height="16" :src="srcRecord"/>
      <span style="color: #4BB1F8; font-size: 14px; margin-left: 4px;" @click="verifyRecord">验真记录</span>
    </div>
  </div>

</template>

<script>
import {Button, Icon, Image as VanImage,} from 'vant';
import srcLogo from "@/assets/login/kaidelogo.png";
import srcRecord from "@/assets/scanverify/record.svg";
import srcScan from "@/assets/scanverify/scan.svg";
import srcCharge from "@/assets/scanverify/charge.svg";
import useProjectStore from "@/store/project";
import {client} from "@/libraries/http";
import useformStore from "@/store/sporadicChargeform";
import chargeProjectStore from "@/store/chargeProject";

export default {
  name: "ScanVerify",
  components: {
    VanImage,
    "van-icon": Icon,
    "van-button": Button,
  },
  data() {
    return {
      srcLogo: srcLogo,
      srcRecord: srcRecord,
      srcScan: srcScan,
      srcCharge: srcCharge,
      project: {},
      userInfo: {},
    }
  },
  created() {
    const projectStore = useProjectStore();
    if (projectStore.isLoaded) {
      this.project = projectStore.projectInfo;
    } else {
      this.getProjectList();
    }
    this.getUserInfo();
  },
  computed: {
    get73Resource() {
      return this.userInfo.resourceList?.find(resource => resource.id.value === '73')
    },
    get74Resource() {
      return this.userInfo.resourceList?.find(resource => resource.id.value === '74')
    },
    get86Resource() {
      return this.userInfo.resourceList?.find(resource => resource.id.value === '86')
    }
  },
  methods: {
    getUserInfo() {
      client.get("/api/h5/guard/user/info")
          .then((res) => {
            this.userInfo = res.data
          })
    },
    scanVerify() {
      this.$router.push({path: '/scanVerify/richScan'});
      // this.$router.push({path:'/scanVerify/verifyRefer', query: {qrCode: 'TFcyMDIzMDYwMDAwMDAyMA=='}});
    },
    sporadicCharges() {
      const form = useformStore();
      form.setForm(undefined)
      this.$router.push({path: '/scanVerify/sporadicCharges'});
    },
    verifyRecord() {
      this.$router.push({path: '/scanVerify/verifyRecord'});
    },
    onChangeProject() {
      if (this.project.onlyOne) return;
      this.getProjectList();
    },
    getProjectList() {
      client.get("/api/h5/guard/projects-all").then((res) => {
        if (res.data.length === 1) {
          const projectStore = useProjectStore();
          projectStore.project(res.data[0], true);
          this.project = projectStore.projectInfo;
        } else {
          const chargeProject = chargeProjectStore();
          chargeProject.setProjectList(res.data);
          chargeProject.setIsChangePro(true);
          this.$router.push({
            name: 'choiceProject',
          });
        }
      });
    },
  },
}
</script>

<style scoped>
.vg-content {
  margin-top: 20px;
  margin-left: 10px;
  margin-right: 10px;
  display: flex;
  flex-direction: column;
  min-height: 100%;
  align-items: center;
}

.logo {
  align-self: flex-start;
}

.button {
  width: 300px;
  height: 44px;
  background-color: #4BA9F6;
  color: white;
  border-radius: 8px;
  font-size: 16px;
}

.vg-content >>> .button .van-button__icon img {
  height: 30px;
  width: 30px;
}

.footer {
  position: fixed;
  bottom: 60px;
  display: flex;
  justify-content: center;
}
</style>
